import EventType from "./EventType.js";
export default EventType;
